export default {
  state: {
    mallConfig: {
      isUseCoupon: 0, // 非proxy监听需要先添加属性
    },
  },
  mutations: {
    UPDATE_MALL_CONFIG(state, val) {
      Object.assign(state.mallConfig, val)
    },
  },
}
